module.exports = __webpack_public_path__ + "623f74d6e8dd9f5855ab38d2a3ded1bf.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/support-widget.eot
// module id = dQ1P
// module chunks = 0